// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--main-layout-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    background: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);
}

/* Fix the header to top of the viewport */
.scl--app-fixed-header{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    box-shadow: 0 1px 0 var(--header-notification-navbar-float-border-color);
}

.scl--outlet-main-container {
    width: 100%;
    min-height: 100vh;
    padding-top: 64px;
    padding-left: 238px;
    background: var(--iz-secondary-bg-colour);
    box-sizing: border-box;           /* padding is already there — good */
}

/* Fixed container for the reusable component sidebar */
.scl--sidebar-fixed-container::-webkit-scrollbar { display: none; } /* Chrome/Safari */

.scl--main-content-mid-style-container{
    width: 100%;
    position: relative;
    overflow: visible;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
}

.scl--app-fixed-header .scl--components-profile-popup-name{
    text-align: left;
}
.scl--app-fixed-header .scl--components-header {
   height: 64px;
   padding: 0 30px;
}
.scl--app-fixed-header .scl--components-header-name{
    font-size: 30px;
    color: var(--typography-text-body-primary);
}
.scl--app-fixed-header .scl--components-header-logo img, .scl--components-header-logo svg{
    width: 35px;
    height: 35px;
}
.scl--app-fixed-header .scl--components-header-brand{
    gap: 20px;
}
.scl--components-pagination-container{
    padding-right: 10px;
}
.scl--components-pagination-activePageButton{
    font-weight: 500 !important;
}

.scl--app-fixed-header .scl--components-header .scl--components-header-profile-avatar, .scl--components-header-profile-avatar svg, .scl--components-header-profile-avatar svg circle{
    width: 40px;
    height: 40px;
}
.scl--app-fixed-header .scl--components-header .scl--components-header-profile-dropdown-icon svg{
    width: 9.33px !important;
    height: 5.33px !important;
}
.scl--app-fixed-header .scl--components-header .scl--components-profile-popup-container.visible .scl--components-profile-popup-menu-item svg, .scl--components-profile-popup-menu-item svg path, .scl--components-profile-popup-menu-item circle{
    stroke: #000000 !important;
    stroke-width: 1.5;
}
.scl--main-outlet-header-right {
  display:     flex;
  flex-direction: row;
  align-items: center;
  gap:         12px;
}
.scl--main-outlet-header-right-notificationBtn{
    height: 26px;
    padding: 0 12px;
    border-right: 1px solid #0000000D;
}
.scl--components-popover-toast-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.scl-components-button-RoundSqureButton{
  padding: 5px 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/layout-controller-mod/layout-serv/outlet/css/mainOutlet.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iFAAiF;AACrF;;AAEA,0CAA0C;AAC1C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,wEAAwE;AAC5E;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,sBAAsB,YAAY,oCAAoC;AAC1E;;AAEA,uDAAuD;AACvD,mDAAmD,aAAa,EAAE,EAAE,kBAAkB;;AAEtF;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;AACA;GACG,YAAY;GACZ,eAAe;AAClB;AACA;IACI,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iCAAiC;AACrC;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B","sourcesContent":[".scl--main-layout-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    background: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);\n}\n\n/* Fix the header to top of the viewport */\n.scl--app-fixed-header{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    background-color: #ffffff;\n    box-shadow: 0 1px 0 var(--header-notification-navbar-float-border-color);\n}\n\n.scl--outlet-main-container {\n    width: 100%;\n    min-height: 100vh;\n    padding-top: 64px;\n    padding-left: 238px;\n    background: var(--iz-secondary-bg-colour);\n    box-sizing: border-box;           /* padding is already there — good */\n}\n\n/* Fixed container for the reusable component sidebar */\n.scl--sidebar-fixed-container::-webkit-scrollbar { display: none; } /* Chrome/Safari */\n\n.scl--main-content-mid-style-container{\n    width: 100%;\n    position: relative;\n    overflow: visible;\n    display: flex;\n    box-sizing: border-box;\n    justify-content: center;\n}\n\n.scl--app-fixed-header .scl--components-profile-popup-name{\n    text-align: left;\n}\n.scl--app-fixed-header .scl--components-header {\n   height: 64px;\n   padding: 0 30px;\n}\n.scl--app-fixed-header .scl--components-header-name{\n    font-size: 30px;\n    color: var(--typography-text-body-primary);\n}\n.scl--app-fixed-header .scl--components-header-logo img, .scl--components-header-logo svg{\n    width: 35px;\n    height: 35px;\n}\n.scl--app-fixed-header .scl--components-header-brand{\n    gap: 20px;\n}\n.scl--components-pagination-container{\n    padding-right: 10px;\n}\n.scl--components-pagination-activePageButton{\n    font-weight: 500 !important;\n}\n\n.scl--app-fixed-header .scl--components-header .scl--components-header-profile-avatar, .scl--components-header-profile-avatar svg, .scl--components-header-profile-avatar svg circle{\n    width: 40px;\n    height: 40px;\n}\n.scl--app-fixed-header .scl--components-header .scl--components-header-profile-dropdown-icon svg{\n    width: 9.33px !important;\n    height: 5.33px !important;\n}\n.scl--app-fixed-header .scl--components-header .scl--components-profile-popup-container.visible .scl--components-profile-popup-menu-item svg, .scl--components-profile-popup-menu-item svg path, .scl--components-profile-popup-menu-item circle{\n    stroke: #000000 !important;\n    stroke-width: 1.5;\n}\n.scl--main-outlet-header-right {\n  display:     flex;\n  flex-direction: row;\n  align-items: center;\n  gap:         12px;\n}\n.scl--main-outlet-header-right-notificationBtn{\n    height: 26px;\n    padding: 0 12px;\n    border-right: 1px solid #0000000D;\n}\n.scl--components-popover-toast-description {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.scl-components-button-RoundSqureButton{\n  padding: 5px 10px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
